export const RARITIES = ["Comune", "Raro", "Esclusivo", "Pre-ordine"];

/** Themed category → visible label + subtitle */
export const THEMED_CATEGORIES = [
    {
        slug: "capitano",
        label: "CAPITANO",
        subtitle: "figure iconiche",
        param: "?category=capitano",
    },
    {
        slug: "grande-rotta",
        label: "GRANDE ROTTA",
        subtitle: "la ciurma classica",
        param: "?category=grande-rotta",
    },
    {
        slug: "tesori",
        label: "TESORI",
        subtitle: "edizioni esclusive",
        param: "?category=tesori",
    },
    {
        slug: "wanted",
        label: "WANTED",
        subtitle: "pre-ordini caccia",
        param: "?category=wanted",
    },
];
